import {BaseElement} from "../interfaces/BaseElement";
import {changeLangToCurrent} from "./langSwitcher/langSwitcher";
import {areAllApartmentsSold, capitalizeFirstLetter} from "../../functions";
import {Buildings, isDesktop, settingsData, projectMode, isMobile, TRoot, UIRoot, components} from "../../settings";
import { Color, LinearSRGBColorSpace } from 'three';
import {ViewMode} from "../../common";

export class IntersectionLegenda extends BaseElement {
    static #rootElement;
    static #color = new Color();
    // static #colorStatuses = config.resources.bundle?.selectionBoxes?.colorStatus;
    static #dictionary = {};
    static #wasShown = false;

    constructor(parentElement) {
        super();

        const colorStatus = config.resources.bundle?.selectionBoxes?.colorStatus;
        const isLiteModeEmpty = (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('empty'));
        const isColorStatusAbsent = !colorStatus || colorStatus.length === 0;
        if (isColorStatusAbsent || isLiteModeEmpty || config.features.privateHouseMode || !parentElement)
            return;

        IntersectionLegenda.#rootElement = this;
        this.addClass('intersection-legenda');
        if(isDesktop) this.addClass('background-backdrop-filter');
        this.appendTo(parentElement);

        IntersectionLegenda.build();
    }

    static build() {
        if (!IntersectionLegenda.#rootElement)
            return;

        if (areAllApartmentsSold(Buildings.getActiveBuilding())) {
            IntersectionLegenda.#clear();
            IntersectionLegenda.setAllApartmentsAreSold();
            IntersectionLegenda.#rootElement.addClass('error');
        } else  {
            IntersectionLegenda.#clear();
            IntersectionLegenda.#createColorDictionary();
            IntersectionLegenda.#addDictionaryDataToRootElement();
        }

        if (isMobile) {
            components.mobileSearch.state === 'hidden'
                ? IntersectionLegenda.show()
                : IntersectionLegenda.hide();
        } else {
            IntersectionLegenda.show();
        }
    }

    static setAllApartmentsAreSold() {
          new BaseElement('span')
            .addAttribute('data-dictionary', 'unavailableBuildingLabel')
            .addClass('language-string', 'intersection-legenda__status')
            .innerHtml(changeLangToCurrent('unavailableBuildingLabel'))
            .appendTo(IntersectionLegenda.#rootElement.DOMElement);
    }

    static remove() {
        IntersectionLegenda.#rootElement?.DOMElement.remove();
        IntersectionLegenda.#rootElement = null;
    }

    static show() {
        if (!IntersectionLegenda.#rootElement)
            return;

        if (isMobile) {
            IntersectionLegenda.#rootElement.removeClass('hide');
        } else {
            IntersectionLegenda.#rootElement.removeClass('hidden')
        }
    }

    static hide() {
        if (!IntersectionLegenda.#rootElement)
            return;

        if (isMobile) {
            IntersectionLegenda.#rootElement.addClass('hide');
        } else {
            IntersectionLegenda.#rootElement.addClass('hidden')
        }
    }

    static #createColorDictionary() {
        let crmStatuses = IntersectionLegenda.#findDistinctStatus(settingsData.allCrmData);
        const colorStatuses = config.resources.bundle?.selectionBoxes?.colorStatus;
        colorStatuses.forEach((item) => {
            if (!crmStatuses.includes(item.status.toLowerCase()))
                return;

            const currentTranslatedStatus = changeLangToCurrent(capitalizeFirstLetter(item.status));
            if (Boolean(currentTranslatedStatus.trim()) && !(currentTranslatedStatus in IntersectionLegenda.#dictionary))
                IntersectionLegenda.#dictionary[currentTranslatedStatus] =
                    IntersectionLegenda.#color.setStyle(`#${item.basic}`,LinearSRGBColorSpace).convertLinearToSRGB().getHexString();
        });
    }

    static #addDictionaryDataToRootElement() {
        for (let key in IntersectionLegenda.#dictionary) {
            IntersectionLegenda.#createHtmlElementForDictionaryItem(key, IntersectionLegenda.#dictionary[key]);
        }
    }

    static #createHtmlElementForDictionaryItem(key, value) {
        const rootElement = new BaseElement()
            .addClass('intersection-legenda__item-wrapper')
            .appendTo(IntersectionLegenda.#rootElement.DOMElement);
        new BaseElement('span')
            .addClass('intersection-legenda__status')
            .innerHtml(key)
            .appendTo(rootElement.DOMElement);
        new BaseElement()
            .addClass('intersection-legenda__color')
            .addStyle('background-color', `#${value}`)
            .appendTo(rootElement.DOMElement);
    }

    static #clear() {
        IntersectionLegenda.#dictionary = {};
        IntersectionLegenda.#rootElement.innerHtml('');
        IntersectionLegenda.#rootElement.removeClass('error');
    }

    static #findDistinctStatus(arr) {
        let statuses = arr.map(obj => obj.status.toLowerCase());
        return [...new Set(statuses)];
    }
}
